/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Refresh_In_ProgressInputs */

const en_us2_auth_refresh_in_progress = /** @type {(inputs: Auth_Refresh_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session is already being renewed. Try again in a moment.`)
};

const pt_br2_auth_refresh_in_progress = /** @type {(inputs: Auth_Refresh_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua sessão já está sendo renovada. Tente de novo em instantes.`)
};

const es_419_auth_refresh_in_progress = /** @type {(inputs: Auth_Refresh_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu sesión ya se está renovando. Intenta de nuevo en un momento.`)
};

const pt_pt2_auth_refresh_in_progress = /** @type {(inputs: Auth_Refresh_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua sessão já está a ser renovada. Tenta outra vez dentro de instantes.`)
};

const fr_fr2_auth_refresh_in_progress = /** @type {(inputs: Auth_Refresh_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta session est déjà en cours de renouvellement. Réessaie dans un instant.`)
};

const de_de2_auth_refresh_in_progress = /** @type {(inputs: Auth_Refresh_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Sitzung wird bereits erneuert. Versuch es gleich noch mal.`)
};

const it_it2_auth_refresh_in_progress = /** @type {(inputs: Auth_Refresh_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua sessione è già in fase di rinnovo. Riprova tra un momento.`)
};

/**
* | output |
* | --- |
* | "Your session is already being renewed. Try again in a moment." |
*
* @param {Auth_Refresh_In_ProgressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_refresh_in_progress = /** @type {((inputs?: Auth_Refresh_In_ProgressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Refresh_In_ProgressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_refresh_in_progress(inputs)
	if (locale === "es-419") return es_419_auth_refresh_in_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_refresh_in_progress(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_refresh_in_progress(inputs)
	if (locale === "de-DE") return de_de2_auth_refresh_in_progress(inputs)
	if (locale === "it-IT") return it_it2_auth_refresh_in_progress(inputs)
	return en_us2_auth_refresh_in_progress(inputs)
});
export { auth_refresh_in_progress as "auth.refresh_in_progress" }